import { Injectable } from '@angular/core';
import { Storage, Drivers } from '@ionic/storage';  // <-- Drivers QUI

@Injectable({ providedIn: 'root' })
export class KvService {
  private storage = new Storage({
    name: '__climacloud',
    driverOrder: [Drivers.IndexedDB, Drivers.LocalStorage], // <-- TIPIZZATI
  });
  private ready = this.storage.create();

  async set<T>(key: string, value: T) {
    await this.ready;
    await this.storage.set(key, value);
  }

  async get<T>(key: string) {
    await this.ready;
    const v = await this.storage.get(key);
    return (v ?? null) as T | null;
  }

  async remove(key: string) {
    await this.ready;
    await this.storage.remove(key);
  }
}
